import { useTranslation } from 'react-i18next'
import type { OrderStatus } from '../../types'

const STATUS_META: Record<OrderStatus, { label: string; color: string }> = {
  CREATED:       { label: 'Created',       color: '#8b8fa8' },
  AI_PROCESSING: { label: 'AI Processing', color: '#6366f1' },
  AI_PROCESSED:  { label: 'AI Processed',  color: '#3b82f6' },
  AI_ERROR:      { label: 'AI Error',      color: '#ef4444' },
  ACCEPTED:      { label: 'Accepted',      color: '#f59e0b' },
  PROCESSED:     { label: 'Processed',     color: '#10b981' },
  APPROVED:      { label: 'Approved',      color: '#06b6d4' },
  REPORT_SENT:   { label: 'Report Sent',   color: '#a3e635' },
}

export function getStatusMeta(status: OrderStatus) {
  return STATUS_META[status] ?? { label: status, color: '#8b8fa8' }
}

/** Returns the next manual status in the linear chain, or null */
export function getNextStatus(status: OrderStatus): OrderStatus | null {
  const chain: OrderStatus[] = [
    'AI_PROCESSED', 'REPORT_SENT',
  ]
  const idx = chain.indexOf(status)
  return idx >= 0 && idx < chain.length - 1 ? chain[idx + 1] : null
}

export default function OrderStatusBadge({ status }: { status: OrderStatus }) {
  const { t } = useTranslation()
  const { color } = getStatusMeta(status)
  const label = t(`admin.status.${status}`, { defaultValue: STATUS_META[status]?.label ?? status })
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 9px',
        borderRadius: 20,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.04em',
        background: `${color}1a`,
        color,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  )
}
